import HTTP from '../HTTP';
import { sumArray } from '@/helpers/math';

export default {
    createSectorSubmission(data) {
        return HTTP.post('/submissions/sector-submissions', data);
    },
    getSectorSubmission(year) {
        return HTTP.get(`submissions/sector-submissions/${year}`);
    },
    getSectorSubmissions() {
        return HTTP.get('submissions/sector-submissions');
    },
    updateSectorSubmission(data) {
        return HTTP.put('/submissions/sector-submissions', data);
    },

};

export const groupeSectorSubmissions = (submissions) => {
    const group = {};

    submissions.forEach((submission) => {
        const {
            q1,
            q2,
            q3,
            q4,
            source_type,
            year,
            user_id,
        } = submission;

        if (!group[year]) {
            group[year] = { user_id, year };
        }
        if (source_type === 'internal') {
            const internalTotal = sumArray([q1, q2, q3, q4]);

            group[year].iq1 = q1;
            group[year].iq2 = q2;
            group[year].iq3 = q3;
            group[year].iq4 = q4;
            group[year].internalTotal = internalTotal;
        } else {
            const externalTotal = sumArray([q1, q2, q3, q4]);
            group[year].eq1 = q1;
            group[year].eq2 = q2;
            group[year].eq3 = q3;
            group[year].eq4 = q4;
            group[year].externalTotal = externalTotal;
        }
    });
    return group;
};
